import styled from 'styled-components';

const InfoMessage = styled.div`
  text-align: right;
  text-decoration: none;
  color: red;
  font-size: 0.875rem;
  display: inline-block;
  padding: 0.5rem 0;
`;

export default InfoMessage;
